import "./SideBar.css";
import React, { useEffect, useState } from "react";
import { RxDashboard } from "react-icons/rx";
import { CgProfile } from "react-icons/cg";
import { HiOutlineUsers } from "react-icons/hi";
import { RiBookMarkFill } from "react-icons/ri";
import { AiFillSetting } from "react-icons/ai";
import { NavLink } from "react-router-dom";
import {
  COURS_PROF_NAVIGATION,
  ETUDIANTS_PROF_NAVIGATION,
  PROFIL_PROF_NAVIGATION,
  PARAMETRE_PROF_NAVIGATION,
} from "../../../Routes/NAVIGATION_PATH";
import logo from "../../../Assets/logo.png";

function SideBar() {
  return (
    <>
      <div id="" className=" container-fluid side-bar">
        <div className="col-auto min-vh-100 side-menu">
          <div className="text-center">
            <img src={logo} alt="" className="img-fluidtt" />
          </div>
          <NavLink to = '' className="nav-link side-link ps-2 ">
            <RxDashboard className="side-rx" />
            <span className="ms-1 d-none d-md-inline fs-6 side-span">
              Dashboard
            </span>
          </NavLink>

          <NavLink to = {COURS_PROF_NAVIGATION} className="sub-btn nav-link ps-2 side-link">
            <RiBookMarkFill />
            <span className="ms-1 d-none d-md-inline fs-6 side-span ">
              Cours
            </span>
          </NavLink>

          <NavLink to = {ETUDIANTS_PROF_NAVIGATION} className="sub-btn nav-link ps-2 side-link">
            <HiOutlineUsers className="side-hi" />
            <span className="ms-1 d-none d-md-inline fs-6 side-span">
              Etudiants
            </span>
          </NavLink>

          <NavLink to = {PROFIL_PROF_NAVIGATION} className="nav-link ps-2 side-link">
            <CgProfile className="side-cg" />
            <span className="ms-1 d-none d-md-inline fs-6 side-span">
              Profil
            </span>
          </NavLink>

          <NavLink to = {PARAMETRE_PROF_NAVIGATION} className="sub-btn nav-link ps-2 side-link">
            <AiFillSetting className="side-hi" />
            <span className="ms-1 d-none d-md-inline fs-6 side-span">
              Paramètre
            </span>
          </NavLink>
        </div>
      </div>
    </>
  );
}

export default SideBar;
